import React from 'react'
import { Link, useParams } from 'react-router';
import { motion } from 'framer-motion';
import { hizmetlerData } from '../data/hizmetler-data';
import { useTranslation } from 'react-i18next';
import { containerVariants, itemVariants, textVariants, container, child, imageVariants } from '../script/animation';
const Hizmetlerimiz = () => {

    const { id1 } = useParams()
    const hizmetler = hizmetlerData.find((category) => category.link === id1);

    const { i18n } = useTranslation();
    const currentLang = i18n.language 

    return (
        <div className="w-full bg-red grid grid-cols-11 relative  calc-height content-start">


            <div className=' col-start-2 col-span-9  w-full text-16 text-customGold1 text-opacity-55 py-10'>
                {/* <Link to={'/'}>Anasayfa / </Link>
                <Link to={'/hizmetler/otomobil'}>Hizmetler / </Link>
                <Link to={`/hizmetler/${id1}`}>{`${hizmetler.name}`}</Link> */}

            </div>




            <div className="col-start-2 col-span-9 lg:col-start-2 lg:col-span-8 z-50 pb-20   grid grid-cols-5">







                <motion.div variants={containerVariants}
                    initial="hidden"
                    animate="visible" className='col-span-5 md:col-span-1   pr-10 mb-10 md:mb-0'>
                    {
                        hizmetlerData.map((item, index) => {
                            return (
                                <motion.div variants={itemVariants}><Link to={`/hizmetler/${item.link}`} className='block'><h5 className={`text-18  font-semibold  border-opacity-50 ${id1 === item.link ? 'border-b-black' : 'border-b-black'}     ${id1 === item.link ? 'text-genesisBlue' : 'text-black'} border-b py-2`}>{item.name[currentLang]}</h5></Link></motion.div>
                            )
                        })
                    }
                </motion.div>


                <motion.div variants={containerVariants}
                    initial="hidden"
                    animate="visible" className='col-span-5 md:col-span-4  overflow-hidden '>
                    <div className='text-45 mb-5 text-genesisBlue'>{hizmetler.name[currentLang]}</div>
                    <div className='  space-y-5'>


                        {
                            hizmetler.text.map((item, index) => {
                                return (
                                    <div>
                                        <motion.h6 className='text-genesisBlue' variants={textVariants} key={index} >{item.title[currentLang]}</motion.h6>
                                        {

                                            item.text[currentLang].map((item, index) => {
                                                return (
                                                    <motion.p variants={textVariants} key={index} className='text-18 text-customGray'>{item}</motion.p>
                                                )
                                            })

                                        }
                                    </div>
                                )
                            })
                        }


                    </div>
                    <motion.div variants={imageVariants} className='h-[50vh] w-full overflow-hidden  mt-5'>
                        <motion.img src={`/images/hizmetler/${id1}/0.jpg`} className='h-full w-full object-cover mt-5' />
                    </motion.div>
                </motion.div>


            </div>

        </div>
    )
}

export default Hizmetlerimiz